import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a3bb019f1b8830014c2a9b6_1782822409206_b5ffdd7c/wikaseducation/src/app/not-found.tsx");
